import React from 'react';
import DemoStage from '../DemoStage.jsx';

/**
 * Animated walkthrough of filling a required-document slot: click the slot →
 * the file lands already renamed to the canonical AE{case}-{Category} pattern →
 * the slot flips to satisfied. Borrows the real .attach-slot classes from
 * CaseDetail's RequiredAttachmentSlots so the demo can't drift from the actual
 * look. Placeholder data only.
 */

const STEPS = [
  {
    caption: 'A required document is an empty slot — the checklist knows what this case needs.',
    scene: 'empty', ms: 2400,
    cursor: 'slot',
  },
  {
    caption: 'Click it — the file picker opens with the category already decided.',
    scene: 'empty', ms: 1600,
    cursor: 'slot', click: true,
  },
  {
    caption: 'The file is renamed on upload so every case file follows the same pattern.',
    scene: 'uploaded', ms: 2600,
  },
  {
    caption: 'The slot flips to satisfied — click it again any time to add more files to the same category.',
    scene: 'uploaded', ms: 3200,
    cursor: 'slot',
  },
];

export default function AttachmentSlotDemo() {
  return (
    <DemoStage steps={STEPS} label="Filling a required-document slot" height={190}>
      {(step) => {
        const scene = step?.scene ?? 'empty';
        const satisfied = scene === 'uploaded';
        return (
          <div className="kb-mock">
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.06em', color: 'var(--text-3)', margin: '0 0 8px' }}>
              Required documents &amp; sign-offs
            </div>
            <div className="attach-slot" data-satisfied={satisfied ? 'true' : 'false'}>
              <button
                type="button"
                className="attach-slot-head"
                tabIndex={-1}
                data-kb-target="slot"
              >
                <span className="attach-slot-icon">{satisfied ? '✓' : '!'}</span>
                <span className="attach-slot-label">Consent form</span>
                <span className="attach-slot-status">
                  {satisfied ? '1 attached · click to add more' : 'Required — click to upload'}
                </span>
              </button>
              {satisfied && (
                <div className="kb-pop" style={{ padding: '0 12px 10px 42px', display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5, color: 'var(--text)' }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round"
                    style={{ width: 12, height: 12, flexShrink: 0, color: 'var(--brand)' }}>
                    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.41 17.41a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
                  </svg>
                  AE42-ConsentForm.pdf
                  <span style={{ color: 'var(--text-3)', fontSize: 11 }}>· was: IMG_4417.pdf</span>
                </div>
              )}
            </div>
          </div>
        );
      }}
    </DemoStage>
  );
}
